module.exports = __webpack_public_path__ + "img/poker-d03.de33ba3f.svg";